import { Component, inject } from "@angular/core";
import { IFactory } from "../core/models/IFactory";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from "@angular/material/dialog";
import { DataAccessService } from "../core/services/data-access.service";
import Swal from "sweetalert2";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { FormsModule } from "@angular/forms";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatButton } from "@angular/material/button";

@Component({
    selector: "app-frozen-week",
    template: `
    <h1 mat-dialog-title>Set frozen weeks</h1>
    <div mat-dialog-content style="padding-top: 4px; padding-bottom: 4px;">
      <form class="example-form">
        <mat-form-field style="width: 100%;">
          <mat-label>Frozen weeks</mat-label>
          <input
            matInput
            type="number"
            min="0"
            max="10"
            [(ngModel)]="frozen_weeks"
            [ngModelOptions]="{ standalone: true }"
          />
        </mat-form-field>
      </form>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="close()">Cancel</button>
      <button mat-button (click)="save()">Save</button>
    </div>
  `,
    styles: [],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, MatFormField, MatLabel, MatInput, MatDialogActions, MatButton]
})
export class FrozenWeekComponent {
  dialogRef = inject<MatDialogRef<FrozenWeekComponent>>(MatDialogRef);
  data = inject<IFactory[]>(MAT_DIALOG_DATA);
  private dataAccess = inject(DataAccessService);

  factory: IFactory[];
  frozen_weeks: number;

  constructor() {
    const data = this.data;

    this.factory = data;
    this.frozen_weeks = this.factory.sort(
      (a, b) => b.frozen_weeks - a.frozen_weeks
    )[0].frozen_weeks;
  }

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.dataAccess
      .getJSON(
        "save_frozen_weeks",
        [],
        [
          { k: "p_frozen_weeks", v: this.frozen_weeks },
          { k: "p_factories", v: this.factory.map((x) => x.id).join(",") },
        ]
      )
      .then((data) => {
        if (data.res != 0) {
          Swal.fire("Error!", data.msg, "error");
        } else {
          this.close();
        }
      });
  }
}
